import React from 'react';
import { Select, FluentProvider, webLightTheme } from '@fluentui/react-components';
import IDropdownOption from '../../../../utils/types/IDropdownOption';

export interface IAgmTrackerOwnerDropdownProps {
  onOwnerUpdate: (_event: React.FormEvent<HTMLSelectElement>, item: IDropdownOption) => void;
  // selectedOption: string;
  label: string;
  defaultSelectedKey: string;
  defaultValue?: string;
  disabled?: boolean;
  isBulkEdit?: boolean;
}

const AgmTrackerOwnerDropdown = (props: IAgmTrackerOwnerDropdownProps): JSX.Element => {
  const {
    defaultSelectedKey,
    defaultValue,
    onOwnerUpdate,
    // selectedOption,
    label,
    disabled,
    isBulkEdit,
  } = props;

  const ownerOptions: IDropdownOption[] = [
    { key: 'CELA', text: 'CELA' },
    { key: 'CONTROLLER', text: 'Controller' },
  ];

  if (isBulkEdit) {
    ownerOptions.unshift({ key: '', text: '--' });
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <label htmlFor="ownerDropdown">{label}</label>
      <Select
        id="ownerDropdown"
        onChange={(event, data): void => {
          const selectedOption = ownerOptions.find((opt) => opt.key === data.value);
          onOwnerUpdate(event, selectedOption || null);
        }}
        defaultValue={defaultValue || defaultSelectedKey}
        disabled={disabled}
      >
        {ownerOptions.map((option) => (
          <option key={option.key} value={option.key}>
            {option.text}
          </option>
        ))}
      </Select>
    </FluentProvider>
  );
};

export default AgmTrackerOwnerDropdown;
